/* RetailManager — widgets vitrine (fidélité, avis, wishlist).
   Fichier généré par RetailManager : ne pas modifier, il est remplacé à
   chaque installation. Script générique : tous les réglages (textes,
   couleurs, sélecteurs) viennent de GET /apps/fidelite/config. */
(function () {
  'use strict'
  if (window.__rmfInit) return
  window.__rmfInit = true

  var BASE = '/apps/fidelite'
  var LS_WISH = 'rmf_wishlist_v1'
  var CFG_KEY = 'rmf_cfg_v1:'
  var CFG_TTL = 60000
  var WISH_MAX = 100
  var MONTHS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre']

  /* Sélecteurs par défaut (Prestige, Dawn, Impulse et thèmes OS 2.0 proches).
     Chaque clé est remplaçable par settings.selectors.<clé> (non vide). */
  var DEF = {
    product_title: '.product-info__title, .product__title, .product-single__title, .product-meta__title, .product-title, [data-product-title], h1',
    product_price: '.product-info__price, .product__price, .product-single__price, .product-meta__price, .price-list, .price, [data-product-price]',
    add_to_cart: 'product-form button[type=submit], form[action*="/cart/add"] button[type=submit], button[name="add"]',
    product_section: '',
    product_card: 'product-card, .product-card, .card-wrapper, .grid-product, .product-item, .product-grid-item, .grid-view-item',
    header_icons: 'header a[href$="/cart"], .header a[href$="/cart"], #shopify-section-header a[href$="/cart"], .shopify-section-group-header-group a[href$="/cart"], header a[href*="/cart"], .header__icon--cart, [data-cart-drawer-toggle]',
    cart_anchor: '.cart__footer, .cart-footer, .cart-recap, .cart__recap, .cart__blocks, form[action$="/cart"], form[action*="/cart?"]'
  }
  var CARD_MEDIA = '.product-card__figure, .card__inner, .card__media, .grid-product__image-mask, .grid-product__image-wrap, .grid-product__image-link, .product-item__image-wrapper, .product-item__image, .product-card__image-wrapper, .product-card__media, .grid-view-item__image-wrapper'
  var OUTSIDE_MAIN = '.rmf, product-recommendations, .product-recommendations, complementary-products, recently-viewed-products, quick-buy-modal, quick-buy-drawer, quick-add-modal, .quick-add-modal, product-quick-add, .product-quick-add, cart-drawer, .cart-drawer, #CartDrawer, cart-notification, .sticky-atc, .product-sticky-bar, sticky-add-to-cart'
  var DRAWERS = 'cart-drawer, .cart-drawer, #CartDrawer, cart-notification, menu-drawer, .menu-drawer, navigation-drawer, .rmf'
  var CONTAINERS = '.container, .page-width, .wrapper, .page-content, .product-container'

  var CTX = {}
  var CFG = null
  var S = null
  var P = null
  var CUS = null
  var LOGGED = false
  var ACTIVE = false
  var VARS = {}
  var ROOT = '/'
  var REF = {}
  var PD = { variant: null, price: null }

  /* ── Utilitaires ── */

  /* Échappement HTML : tout ce qui vient de l'API ou des réglages passe par
     là avant innerHTML — un libellé contenant du HTML ne s'exécute jamais. */
  function rmEsc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
    })
  }
  var esc = rmEsc

  function qsa(root, s) {
    if (!s) return []
    try { return Array.prototype.slice.call((root || document).querySelectorAll(s)) } catch (e) { return [] }
  }
  function qs(root, s) {
    if (!s) return null
    try { return (root || document).querySelector(s) } catch (e) { return null }
  }
  function closest(el, s) {
    if (!s || !el || !el.closest) return null
    try { return el.closest(s) } catch (e) { return null }
  }
  function sel(key) {
    var v = S && S.selectors && S.selectors[key]
    return typeof v === 'string' && v.trim() ? v.trim() : DEF[key]
  }
  function frag(html) {
    var t = document.createElement('template')
    t.innerHTML = html.trim()
    return t.content.firstElementChild
  }
  function visible(el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length))
  }
  function storage(kind) {
    try { return window[kind] } catch (e) { return null }
  }
  function sGet(kind, key) {
    try { var st = storage(kind); var raw = st && st.getItem(key); return raw ? JSON.parse(raw) : null } catch (e) { return null }
  }
  function sSet(kind, key, val) {
    try { var st = storage(kind); if (st) st.setItem(key, JSON.stringify(val)) } catch (e) { /* stockage indisponible */ }
  }
  function sDel(kind, key) {
    try { var st = storage(kind); if (st) st.removeItem(key) } catch (e) { /* stockage indisponible */ }
  }
  function fmtInt(n) {
    try { return new Intl.NumberFormat('fr-FR').format(Math.round(Number(n) || 0)) } catch (e) { return String(Math.round(Number(n) || 0)) }
  }
  function fmtDec(n) {
    try { return new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(Number(n) || 0) } catch (e) { return (Number(n) || 0).toFixed(1) }
  }
  function fmtDate(v) {
    var d = new Date(v)
    return isNaN(d.getTime()) ? '' : d.toLocaleDateString('fr-FR')
  }
  function groupDigits(intStr, sep) {
    return intStr.replace(/\B(?=(\d{3})+(?!\d))/g, sep)
  }
  /* Prix en unités (ex. 79.5) → format boutique (shop.money_format) quand il
     est reconnu, sinon Intl fr-FR dans la devise de la boutique. */
  function fmtMoney(amount) {
    var n = Number(amount)
    if (amount == null || amount === '' || !isFinite(n)) return ''
    var f = String(CTX.money_format || '').replace(/<[^>]*>/g, '')
    var m = /\{\{\s*(\w+)\s*\}\}/.exec(f)
    var fixed = n.toFixed(2).split('.')
    var out = null
    if (m) {
      if (m[1] === 'amount') out = groupDigits(fixed[0], ',') + '.' + fixed[1]
      else if (m[1] === 'amount_with_comma_separator') out = groupDigits(fixed[0], '.') + ',' + fixed[1]
      else if (m[1] === 'amount_no_decimals') out = groupDigits(String(Math.round(n)), ',')
      else if (m[1] === 'amount_no_decimals_with_comma_separator') out = groupDigits(String(Math.round(n)), '.')
      else if (m[1] === 'amount_with_apostrophe_separator') out = groupDigits(fixed[0], "'") + '.' + fixed[1]
      else if (m[1] === 'amount_with_space_separator') out = groupDigits(fixed[0], ' ') + ',' + fixed[1]
    }
    if (out != null) return f.replace(m[0], out).trim()
    try { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: CTX.currency || 'EUR' }).format(n) } catch (e) { return n.toFixed(2) }
  }
  function fill(tpl, extra) {
    return String(tpl == null ? '' : tpl).replace(/\{\{\s*(\w+)\s*\}\}/g, function (all, k) {
      var v = extra && extra[k] != null ? extra[k] : VARS[k]
      return v == null ? '' : String(v)
    })
  }
  /* Version HTML : gabarit échappé, valeurs échappées, sauf rawVars (HTML
     construit par le script, déjà sûr). */
  function fillHtml(tpl, rawVars) {
    return esc(tpl).replace(/\{\{\s*(\w+)\s*\}\}/g, function (all, k) {
      if (rawVars && rawVars[k] != null) return rawVars[k]
      var v = VARS[k]
      return v == null ? '' : esc(v)
    })
  }
  function throttle(fn, wait) {
    var t = null
    return function () {
      if (t) return
      t = setTimeout(function () { t = null; try { fn() } catch (e) { /* no-op */ } }, wait)
    }
  }
  function loginUrl() {
    return ROOT + 'account/login?return_url=' + encodeURIComponent(location.pathname + location.search)
  }
  function goLogin() { location.href = loginUrl() }
  function imgUrl(src, width) {
    if (!src) return ''
    var s = String(src)
    if (/cdn\.shopify\.com|\/cdn\/shop\//.test(s) && !/[?&]width=/.test(s)) s += (s.indexOf('?') >= 0 ? '&' : '?') + 'width=' + width
    return s
  }

  async function api(path, o) {
    o = o || {}
    var init = { method: o.method || 'GET', credentials: 'same-origin', headers: { Accept: 'application/json' } }
    if (o.json !== undefined) {
      init.headers['Content-Type'] = 'application/json'
      init.body = JSON.stringify(o.json)
    } else if (o.form) {
      init.body = o.form
    }
    try {
      var r = await fetch(path, init)
      var data = null
      try { data = await r.json() } catch (e) { data = null }
      return { ok: r.ok, status: r.status, data: data }
    } catch (e) {
      return { ok: false, status: 0, data: null }
    }
  }

  /* ── Icônes (SVG trait 1,5) ── */
  var ICONS = {
    gift: '<path d="M20 12v9H4v-9M2 7h20v5H2zM12 21V7M12 7H7.5a2.5 2.5 0 1 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 1 0 0-5C13 2 12 7 12 7z"/>',
    star: '<path d="M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8-5.2-2.7-5.2 2.7 1-5.8-4.3-4.1 5.9-.9z"/>',
    heart: '<path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/>',
    crown: '<path d="M3 8l4.5 4L12 5l4.5 7L21 8l-2 11H5z"/>',
    close: '<path d="M6 6l12 12M18 6 6 18"/>',
    check: '<path d="M20 6 9 17l-5-5"/>',
    copy: '<rect x="9" y="9" width="11" height="11" rx="2"/><path d="M5 15V6a2 2 0 0 1 2-2h8"/>',
    plus: '<path d="M12 5v14M5 12h14"/>',
    camera: '<path d="M4 8h3l2-3h6l2 3h3v11H4z"/><circle cx="12" cy="13" r="3.5"/>'
  }
  function icon(name, cls) {
    return '<svg class="rmf-i rmf-i-' + name + (cls ? ' ' + cls : '') + '" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' + (ICONS[name] || '') + '</svg>'
  }
  function starsHtml(avg, cls) {
    var v = Math.max(0, Math.min(5, Number(avg) || 0))
    var row = ''
    for (var i = 0; i < 5; i++) row += icon('star')
    return '<span class="rmf-stars' + (cls ? ' ' + cls : '') + '" role="img" aria-label="' + esc('Note : ' + fmtDec(v) + ' sur 5') + '">' +
      '<span class="rmf-stars__bg">' + row + '</span><span class="rmf-stars__fg" style="width:' + (v / 5 * 100).toFixed(1) + '%">' + row + '</span></span>'
  }

  /* ── Thème : couleurs lues sur la boutique ou saisies dans RM ── */
  var BLACK = [17, 17, 17, 1]
  var WHITE = [255, 255, 255, 1]
  function parseRgb(s) {
    var m = /rgba?\(([^)]+)\)/.exec(s || '')
    if (!m) return null
    var p = m[1].split(/[\s,/]+/).filter(Boolean).map(parseFloat)
    if (p.length < 3 || p.slice(0, 3).some(isNaN)) return null
    var a = p.length > 3 && !isNaN(p[3]) ? p[3] : 1
    if (a > 1) a = a / 100
    return [p[0], p[1], p[2], a]
  }
  function parseHex(s) {
    var m = /^#([0-9a-f]{6})$/i.exec(String(s || '').trim())
    if (!m) return null
    var n = parseInt(m[1], 16)
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255, 1]
  }
  function mix(a, b, t) {
    return [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t, a[2] + (b[2] - a[2]) * t, 1]
  }
  function opaque(c) {
    if (!c || c[3] < 0.05) return null
    return c[3] < 1 ? mix(WHITE, c, c[3]) : c
  }
  function lum(c) {
    var a = [c[0], c[1], c[2]].map(function (v) {
      v /= 255
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4)
    })
    return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2]
  }
  function contrast(a, b) {
    var l1 = lum(a)
    var l2 = lum(b)
    return (Math.max(l1, l2) + 0.05) / (Math.min(l1, l2) + 0.05)
  }
  function readable(bg, fg, min) {
    if (fg && contrast(bg, fg) >= min) return fg
    return contrast(bg, WHITE) >= contrast(bg, BLACK) ? WHITE : BLACK
  }
  function rgba(c, a) {
    return 'rgba(' + Math.round(c[0]) + ',' + Math.round(c[1]) + ',' + Math.round(c[2]) + ',' + (a == null ? 1 : a) + ')'
  }
  function findThemeButton() {
    var list = qsa(document, sel('add_to_cart') + ', .button--primary, .btn--primary, .button, .btn, button[type=submit]')
    for (var i = 0; i < list.length && i < 60; i++) {
      var b = list[i]
      if (closest(b, '.rmf') || !visible(b)) continue
      var cs = getComputedStyle(b)
      var bg = opaque(parseRgb(cs.backgroundColor))
      if (!bg) continue
      return { bg: bg, fg: parseRgb(cs.color), tt: cs.textTransform, ls: cs.letterSpacing }
    }
    return null
  }
  function applyTheme() {
    var st = S.style || {}
    var bcs = getComputedStyle(document.body)
    var surface = opaque(parseRgb(bcs.backgroundColor)) || opaque(parseRgb(getComputedStyle(document.documentElement).backgroundColor)) || WHITE
    var text = opaque(parseRgb(bcs.color)) || BLACK
    var btn = findThemeButton()
    var primary = btn ? btn.bg : text
    var onPrimary = btn ? opaque(btn.fg) : null
    if (st.mode === 'custom') {
      surface = parseHex(st.surface) || surface
      text = parseHex(st.text) || text
      primary = parseHex(st.primary) || primary
      onPrimary = parseHex(st.primary_text) || onPrimary
    }
    text = readable(surface, text, 4.5)
    /* Bouton du thème invisible sur le fond (bouton « contour ») : texte. */
    if (contrast(primary, surface) < 1.4) primary = text
    onPrimary = readable(primary, onPrimary, 3)
    var r = Math.max(0, Math.min(24, Math.round(Number(st.radius) || 0)))
    var rules = [
      '--rmf-primary:' + rgba(primary),
      '--rmf-on-primary:' + rgba(onPrimary),
      '--rmf-primary-soft:' + rgba(primary, 0.1),
      '--rmf-surface:' + rgba(surface),
      '--rmf-text:' + rgba(text),
      '--rmf-muted:' + rgba(mix(surface, text, 0.7)),
      '--rmf-line:' + rgba(text, 0.14),
      '--rmf-soft:' + rgba(mix(surface, text, 0.045)),
      '--rmf-soft-2:' + rgba(mix(surface, text, 0.1)),
      '--rmf-radius:' + r + 'px',
      '--rmf-radius-sm:' + Math.min(r, 8) + 'px'
    ]
    if (st.mode !== 'custom' && btn) {
      if (btn.tt && btn.tt !== 'none') rules.push('--rmf-btn-tt:' + btn.tt)
      if (btn.ls && btn.ls !== 'normal' && /^-?[\d.]+px$/.test(btn.ls) && Math.abs(parseFloat(btn.ls)) < 4) rules.push('--rmf-btn-ls:' + btn.ls)
    }
    var tag = document.getElementById('rmf-vars')
    if (!tag) {
      tag = document.createElement('style')
      tag.id = 'rmf-vars'
      document.head.appendChild(tag)
    }
    /* html .rmf : plus spécifique que les valeurs par défaut du CSS. */
    tag.textContent = 'html .rmf{' + rules.join(';') + '}'
  }

  /* ── Couche fixe (launcher, toast, tiroir, fenêtres) ── */
  var LAYER = null
  var TOAST = null
  var toastTimer = null
  function layer() {
    if (LAYER && LAYER.isConnected) return LAYER
    LAYER = document.createElement('div')
    LAYER.className = 'rmf rmf-layer'
    TOAST = document.createElement('div')
    TOAST.className = 'rmf-toast'
    TOAST.setAttribute('role', 'status')
    TOAST.setAttribute('aria-live', 'polite')
    LAYER.appendChild(TOAST)
    document.body.appendChild(LAYER)
    return LAYER
  }
  function toast(msg) {
    layer()
    TOAST.innerHTML = icon('check') + '<span>' + esc(msg) + '</span>'
    TOAST.classList.add('is-on')
    clearTimeout(toastTimer)
    toastTimer = setTimeout(function () { TOAST.classList.remove('is-on') }, 2800)
  }

  var scrollLocks = 0
  function lockScroll(on) {
    scrollLocks = Math.max(0, scrollLocks + (on ? 1 : -1))
    var v = scrollLocks > 0 ? 'hidden' : ''
    document.documentElement.style.overflow = v
    document.body.style.overflow = v
  }
  function reducedMotion() {
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches } catch (e) { return false }
  }
  function focusables(root) {
    return qsa(root, 'a[href], button:not([disabled]), input:not([disabled]):not([type=hidden]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])').filter(visible)
  }
  /* Fenêtre modale : piège du focus, Échap, clic sur le voile, scroll bloqué. */
  function makeDialog(root, panel) {
    var open = false
    var back = null
    function onKey(e) {
      if (!open) return
      if (e.key === 'Escape') { e.stopPropagation(); hide(); return }
      if (e.key !== 'Tab') return
      var f = focusables(panel)
      if (!f.length) { e.preventDefault(); panel.focus(); return }
      var first = f[0]
      var last = f[f.length - 1]
      var a = document.activeElement
      if (e.shiftKey && (a === first || a === panel)) { e.preventDefault(); last.focus() } else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus() }
    }
    function show() {
      if (open) return
      open = true
      back = document.activeElement
      root.hidden = false
      void root.offsetWidth
      root.classList.add('is-open')
      lockScroll(true)
      var f = focusables(panel)
      try { (f[0] || panel).focus({ preventScroll: true }) } catch (e) { /* no-op */ }
    }
    function hide() {
      if (!open) return
      open = false
      root.classList.remove('is-open')
      lockScroll(false)
      setTimeout(function () { if (!open) root.hidden = true }, reducedMotion() ? 0 : 260)
      if (back && back.focus && back.isConnected) { try { back.focus({ preventScroll: true }) } catch (e) { /* no-op */ } }
    }
    root.addEventListener('keydown', onKey)
    root.addEventListener('click', function (e) {
      var t = e.target
      if (t && t.closest && t.closest('[data-rmf-close]')) hide()
    })
    return { show: show, hide: hide, isOpen: function () { return open } }
  }

  /* ── Configuration (une requête par page, cache 60 s) ── */
  function cfgKey() { return CFG_KEY + (CTX.customer_id || (CTX.logged_in ? 'in' : 'guest')) }
  async function loadConfig(force) {
    var key = cfgKey()
    if (!force) {
      var c = sGet('sessionStorage', key)
      if (c && c.d && c.t && Date.now() - c.t < CFG_TTL) return c.d
    }
    // Thème non publié (copie d'aperçu) : le serveur montre le programme même
    // en pause, en lecture seule — pour valider la vitrine avant la bascule.
    var previewTheme = !!(window.Shopify && window.Shopify.theme && window.Shopify.theme.role && window.Shopify.theme.role !== 'main')
    var r = await api(BASE + '/config' + (previewTheme ? '?preview=1' : ''))
    if (!r.ok || !r.data || !r.data.settings) return null
    sSet('sessionStorage', key, { t: Date.now(), d: r.data })
    return r.data
  }
  function setConfig(c) {
    CFG = c
    S = c.settings
    P = c.program || null
    CUS = c.customer || null
    LOGGED = !!c.logged_in
    ACTIVE = !!(c.active && P)
    VARS = {
      monnaie: P ? String(P.currency || '').toLowerCase() : '',
      boutique: c.shop_name || '',
      programme: P ? P.name || '' : ''
    }
  }
  async function refreshConfig() {
    var c = await loadConfig(true)
    if (!c) return
    setConfig(c)
    renderLauncher()
  }

  /* ── Wishlist : état unique (serveur si connectée, navigateur sinon) ── */
  var W = { items: [], loaded: false }
  function wNorm(it) {
    it = it || {}
    return {
      product_id: it.product_id != null && it.product_id !== '' ? String(it.product_id) : '',
      variant_id: it.variant_id != null && it.variant_id !== '' ? String(it.variant_id) : null,
      handle: it.handle ? String(it.handle) : '',
      title: it.title ? String(it.title) : '',
      image: it.image ? String(it.image) : '',
      price: it.price == null || it.price === '' || !isFinite(Number(it.price)) ? null : Number(it.price)
    }
  }
  function wPayload(it) {
    return {
      product_id: Number(it.product_id),
      variant_id: it.variant_id ? Number(it.variant_id) : null,
      handle: it.handle || null,
      title: it.title || null,
      image: it.image || null,
      price: it.price
    }
  }
  function wFind(pid, handle) {
    for (var i = 0; i < W.items.length; i++) {
      var it = W.items[i]
      if ((pid && it.product_id === String(pid)) || (handle && it.handle === handle)) return it
    }
    return null
  }
  function wLocal() {
    var a = sGet('localStorage', LS_WISH)
    return Array.isArray(a) ? a.map(wNorm).filter(function (i) { return i.product_id }) : []
  }
  function wEmit() {
    try {
      document.dispatchEvent(new CustomEvent('rmf:wishlist-change', { detail: { count: W.items.length, items: W.items.slice() } }))
    } catch (e) { /* no-op */ }
  }
  function wishlistUsed() {
    return !!(S.product.wishlist_button || S.collection.wishlist_hearts || S.wishlist.header_icon)
  }
  async function wLoad() {
    if (LOGGED) {
      var local = wLocal()
      if (local.length) {
        var m = await api(BASE + '/wishlist/merge', { method: 'POST', json: { items: local.map(wPayload) } })
        if (m.ok && m.data && m.data.ok !== false) sDel('localStorage', LS_WISH)
      }
      var r = await api(BASE + '/wishlist/items')
      if (r.ok && r.data && Array.isArray(r.data.items)) W.items = r.data.items.map(wNorm)
    } else {
      W.items = S.wishlist.guest_enabled ? wLocal() : []
    }
    W.loaded = true
    wEmit()
  }
  async function wToggle(item) {
    if (!LOGGED && !S.wishlist.guest_enabled) { goLogin(); return }
    item = wNorm(item)
    if (!item.product_id) return
    var existing = wFind(item.product_id, item.handle)
    var adding = !existing
    var prev = W.items.slice()
    if (adding) W.items.push(item)
    else W.items = W.items.filter(function (x) { return x !== existing })
    if (!LOGGED) {
      if (W.items.length > WISH_MAX) W.items = W.items.slice(-WISH_MAX)
      sSet('localStorage', LS_WISH, W.items)
      wEmit()
      toast(adding ? 'Ajouté à votre wishlist' : 'Retiré de votre wishlist')
      return
    }
    wEmit()
    toast(adding ? 'Ajouté à votre wishlist' : 'Retiré de votre wishlist')
    var r = await api(BASE + '/wishlist/toggle', { method: 'POST', json: wPayload(existing || item) })
    if (r.status === 401) { W.items = prev; wEmit(); goLogin(); return }
    if (!r.ok || !r.data) { W.items = prev; wEmit(); toast('Action impossible pour le moment.'); return }
    var on = !!r.data.in_wishlist
    if (on !== adding) {
      /* Le serveur fait foi (liste modifiée ailleurs entre-temps). */
      var found = wFind(item.product_id, item.handle)
      if (on && !found) W.items.push(item)
      if (!on && found) W.items = W.items.filter(function (x) { return x !== found })
      wEmit()
      toast(on ? 'Ajouté à votre wishlist' : 'Retiré de votre wishlist')
    }
  }
  function setHeart(btn, on) {
    btn.classList.toggle('is-on', !!on)
    btn.setAttribute('aria-pressed', on ? 'true' : 'false')
    btn.setAttribute('aria-label', on ? 'Retirer de la wishlist' : 'Ajouter à la wishlist')
  }

  /* Produits des cartes : /products/<handle>.js, à la demande, en cache. */
  var PCACHE = {}
  function fetchProduct(handle) {
    if (!PCACHE[handle]) {
      PCACHE[handle] = fetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null })
        .catch(function () { return null })
    }
    return PCACHE[handle]
  }
  function productToItem(p) {
    var vs = p.variants || []
    var v = vs.filter(function (x) { return x.available })[0] || vs[0] || null
    var cents = v && v.price != null ? v.price : p.price
    var image = p.featured_image
    if (image && typeof image === 'object') image = image.src || image.url || ''
    return { product_id: p.id, variant_id: v ? v.id : null, handle: p.handle, title: p.title, image: imgUrl(image, 400), price: cents != null ? Number(cents) / 100 : null }
  }

  /* ── Cœurs sur les cartes produit ── */
  function cardHandle(card) {
    var h = card.getAttribute('handle') || card.getAttribute('data-handle') || (card.dataset && card.dataset.productHandle)
    if (h) return h
    var a = qs(card, 'a[href*="/products/"]')
    var m = a && /\/products\/([^/?#]+)/.exec(a.getAttribute('href') || '')
    if (!m) return ''
    try { return decodeURIComponent(m[1]) } catch (e) { return m[1] }
  }
  function mountCardHearts() {
    if (!S.collection.wishlist_hearts) return
    var cs = sel('product_card')
    qsa(document, cs).forEach(function (card) {
      if (qs(card, '.rmf-card-heart') || closest(card, '.rmf')) return
      if (card.parentElement && closest(card.parentElement, cs)) return
      var handle = cardHandle(card)
      if (!handle) return
      var media = qs(card, CARD_MEDIA)
      if (!media) {
        var img = qs(card, 'img')
        media = img ? (closest(img, 'a') || img.parentElement) : null
      }
      if (!media || closest(media, '.rmf')) return
      if (getComputedStyle(media).position === 'static') media.classList.add('rmf-rel')
      var b = document.createElement('button')
      b.type = 'button'
      b.className = 'rmf rmf-b rmf-card-heart'
      b.setAttribute('data-handle', handle)
      b.innerHTML = icon('heart')
      setHeart(b, !!wFind(null, handle))
      b.addEventListener('click', onCardHeart)
      media.appendChild(b)
      INSERTS++
    })
  }
  async function onCardHeart(e) {
    e.preventDefault()
    e.stopPropagation()
    var b = e.currentTarget
    if (!LOGGED && !S.wishlist.guest_enabled) { goLogin(); return }
    var handle = b.getAttribute('data-handle')
    var existing = wFind(null, handle)
    if (existing && existing.product_id) { wToggle(existing); return }
    if (b.getAttribute('aria-busy') === 'true') return
    b.setAttribute('aria-busy', 'true')
    var p = await fetchProduct(handle)
    b.removeAttribute('aria-busy')
    if (!p || !p.id) { toast('Action impossible pour le moment.'); return }
    wToggle(productToItem(p))
  }
  function syncHearts() {
    qsa(document, '.rmf-card-heart').forEach(function (b) { setHeart(b, !!wFind(null, b.getAttribute('data-handle'))) })
    if (REF.heart && CTX.product) setHeart(REF.heart, !!wFind(CTX.product.id, CTX.product.handle))
  }

  /* ── Icône wishlist de l'en-tête + tiroir ── */
  function mountHeader() {
    if (!S.wishlist.header_icon) return
    if (REF.hdr && REF.hdr.isConnected) return
    var place = headerPlacement()
    if (!place) return
    // Style et taille d'icône repris du lien panier (toujours visible).
    var a = place.iconSrc || place.ref
    var link = document.createElement('a')
    link.href = BASE + '/wishlist'
    var keep = String(a.className && a.className.baseVal != null ? a.className.baseVal : a.className || '').split(/\s+/).filter(function (c) {
      return c && !/cart|drawer|toggle|^js-|bubble|count|hidden|account|login/i.test(c)
    })
    link.className = keep.concat(['rmf', 'rmf-hdr']).join(' ')
    link.setAttribute('role', 'button')
    link.setAttribute('aria-haspopup', 'dialog')
    link.setAttribute('aria-label', 'Wishlist')
    link.innerHTML = '<span class="rmf-hdr__in">' + icon('heart') + '<span class="rmf-hdr__count" hidden></span></span>'
    var svg = qs(a, 'svg')
    var w = svg ? svg.getBoundingClientRect().width : 0
    if (w >= 14 && w <= 40) {
      var ic = link.querySelector('.rmf-i')
      ic.style.width = w + 'px'
      ic.style.height = w + 'px'
    }
    link.addEventListener('click', function (e) { e.preventDefault(); openDrawer() })
    var node = link
    if (place.wrapTag) {
      // Même structure que les autres icônes (ex. <li> d'une liste d'icônes).
      node = document.createElement(place.wrapTag)
      if (place.wrapClass) node.className = place.wrapClass
      node.appendChild(link)
    }
    place.parent.insertBefore(node, place.before)
    INSERTS++
    REF.hdr = link
    syncHeader()
  }
  /* Placement du cœur d'en-tête. Réglage « sélecteur » renseigné : avant cet
     élément. Sinon : juste APRÈS l'icône compte client (au niveau des autres
     icônes — si le thème masque le compte sur mobile, le cœur se retrouve à
     côté des icônes suivantes, ex. la recherche), à défaut juste avant
     l'icône panier. Liens reconnus STRICTEMENT par leur chemin (/cart,
     /account) : un lien de menu « carte cadeau » n'est jamais pris pour le
     panier. */
  function hrefPath(a) {
    try { return new URL(a.getAttribute('href') || '', location.href).pathname.replace(/\/+$/, '') } catch (e) { return '' }
  }
  var HDR_ROOT = 'header, .header, #shopify-section-header, .shopify-section-group-header-group, [data-section-type="header"]'
  // Menus de navigation principaux (liens de catégories) — les icônes compte /
  // recherche / panier sont souvent aussi dans un <nav> (Prestige :
  // .header__secondary-nav) : on n'exclut donc que les menus de contenu.
  var HDR_MENUS = '[role="menubar"], .mega-menu, .header__menu, .header__primary-nav, .header__inline-menu, .header__dropdown-menu, .header__menu-disclosure, .menu-drawer, .list-menu'
  function iconLinks(test) {
    var roots = qsa(document, HDR_ROOT)
    var out = []
    roots.forEach(function (r) {
      qsa(r, 'a[href]').forEach(function (a) {
        if (out.indexOf(a) !== -1 || closest(a, DRAWERS) || closest(a, HDR_MENUS) || closest(a, '.rmf')) return
        if (test(hrefPath(a))) out.push(a)
      })
    })
    return out
  }
  function commonItem(a, b) {
    // Plus petit ancêtre commun de a et b, et l'enfant de cet ancêtre qui contient a.
    var anc = b
    while (anc && !anc.contains(a)) anc = anc.parentElement
    if (!anc) return null
    var item = a
    while (item.parentElement && item.parentElement !== anc) item = item.parentElement
    return { parent: anc, item: item }
  }
  function headerPlacement() {
    var custom = S.selectors && S.selectors.header_icons
    if (custom) {
      var list = qsa(document, custom).filter(function (el) { return !closest(el, DRAWERS) })
      var el = list.filter(visible)[0] || list[0]
      return el && el.parentNode ? { ref: el, iconSrc: el, parent: el.parentNode, before: el } : null
    }
    var carts = iconLinks(function (p) { return /(^|\/)cart$/.test(p) })
    var cart = carts.filter(visible)[0] || carts[0]
    if (!cart) return null
    var accounts = iconLinks(function (p) { return /(^|\/)account(\/login)?$/.test(p) })
    // Composant compte natif (<shopify-account>, Prestige/Horizon) ou élément
    // marqué « account » dans la zone des icônes.
    qsa(document, HDR_ROOT).forEach(function (r) {
      qsa(r, 'shopify-account, [class*="account-link"], [class*="icon--account"], [class*="header__account"]').forEach(function (el) {
        if (accounts.indexOf(el) === -1 && !closest(el, DRAWERS) && !closest(el, HDR_MENUS)) accounts.push(el)
      })
    })
    var account = accounts.filter(function (x) { return x !== cart && !x.contains(cart) && commonItem(x, cart) })[0]
    var ref = account || cart
    var pos = account ? commonItem(account, cart) : null
    var parent, before, item
    if (pos && pos.item !== pos.parent) {
      item = pos.item
      parent = pos.parent
      before = item.nextSibling
    } else {
      item = cart
      while (item.parentElement && item.parentElement.children.length === 1 && item.parentElement.tagName !== 'UL') item = item.parentElement
      parent = item.parentElement
      before = item
    }
    if (!parent) return null
    var wrapTag = null
    var wrapClass = ''
    // Élément de structure (li, div…) : on crée le même, sinon lien direct.
    if (item !== cart && !/^(A|BUTTON)$/.test(item.tagName)) {
      wrapTag = item.tagName.toLowerCase()
      // Classe d'un élément toujours visible (celui du panier), sans ses
      // marqueurs propres au panier.
      var cartItem = commonItem(cart, ref) ? commonItem(cart, ref).item : item
      var src = cartItem && cartItem.tagName === item.tagName ? cartItem : item
      wrapClass = String(src.className || '').split(/\s+/).filter(function (c) {
        return c && !/cart|account|login|hidden|drawer|toggle|count/i.test(c)
      }).join(' ')
    }
    return { ref: ref, iconSrc: cart, parent: parent, before: before, wrapTag: wrapTag, wrapClass: wrapClass }
  }

  function syncHeader() {
    var n = W.items.length
    qsa(document, '.rmf-hdr').forEach(function (l) {
      var c = l.querySelector('.rmf-hdr__count')
      if (c) { c.textContent = n > 99 ? '99+' : String(n); c.hidden = !n }
      l.setAttribute('aria-label', n ? 'Wishlist, ' + n + ' article' + (n > 1 ? 's' : '') : 'Wishlist')
    })
  }

  var DRAWER = null
  function buildDrawer() {
    if (DRAWER && DRAWER.root.isConnected) return DRAWER
    var root = frag(
      '<div class="rmf-drawer" hidden>' +
        '<div class="rmf-overlay" data-rmf-close></div>' +
        '<aside class="rmf-drawer__panel rmf-ui" role="dialog" aria-modal="true" aria-labelledby="rmf-drawer-title" tabindex="-1">' +
          '<div class="rmf-drawer__hd"><h2 class="rmf-h rmf-drawer__title" id="rmf-drawer-title"></h2>' +
          '<button type="button" class="rmf-b rmf-x" data-rmf-close aria-label="Fermer">' + icon('close') + '</button></div>' +
          '<div class="rmf-drawer__bd"></div>' +
          '<div class="rmf-drawer__ft"></div>' +
        '</aside>' +
      '</div>')
    layer().appendChild(root)
    var panel = root.querySelector('.rmf-drawer__panel')
    DRAWER = { root: root, panel: panel, dlg: makeDialog(root, panel) }
    root.addEventListener('click', onDrawerClick)
    return DRAWER
  }
  function renderDrawer() {
    if (!DRAWER) return
    var n = W.items.length
    DRAWER.panel.querySelector('.rmf-drawer__title').textContent = fill(S.wishlist.drawer_title) + ' (' + n + ')'
    var bd = DRAWER.panel.querySelector('.rmf-drawer__bd')
    if (!W.loaded) {
      bd.innerHTML = '<p class="rmf-muted">Chargement…</p>'
    } else if (!n) {
      bd.innerHTML = '<div class="rmf-empty">' + icon('heart') + '<p>Votre wishlist est vide.</p><p class="rmf-muted">Touchez le cœur d\'un article pour le retrouver ici.</p></div>'
    } else {
      bd.innerHTML = '<ul class="rmf-wl">' + W.items.slice().reverse().map(function (it) {
        var url = it.handle ? ROOT + 'products/' + encodeURIComponent(it.handle) + (it.variant_id ? '?variant=' + encodeURIComponent(it.variant_id) : '') : ''
        var img = it.image ? '<img src="' + esc(imgUrl(it.image, 200)) + '" alt="" loading="lazy">' : ''
        var media = url ? '<a class="rmf-wl__img" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' + img + '</a>' : '<span class="rmf-wl__img">' + img + '</span>'
        var title = url ? '<a class="rmf-wl__title" href="' + esc(url) + '">' + esc(it.title || it.handle) + '</a>' : '<span class="rmf-wl__title">' + esc(it.title || it.handle) + '</span>'
        var action = it.variant_id
          ? '<button type="button" class="rmf-b rmf-btn rmf-btn--sm" data-act="add" data-variant="' + esc(it.variant_id) + '">Ajouter au panier</button>'
          : (url ? '<a class="rmf-btn rmf-btn--sm" href="' + esc(url) + '">Voir le produit</a>' : '')
        return '<li class="rmf-wl__it">' + media +
          '<div class="rmf-wl__info">' + title +
            '<div class="rmf-wl__price">' + esc(fmtMoney(it.price)) + '</div>' +
            '<div class="rmf-wl__acts">' + action +
            '<button type="button" class="rmf-b rmf-link" data-act="remove" data-pid="' + esc(it.product_id) + '">Retirer</button></div>' +
          '</div></li>'
      }).join('') + '</ul>'
    }
    var ft = DRAWER.panel.querySelector('.rmf-drawer__ft')
    if (LOGGED) {
      ft.innerHTML = '<a class="rmf-btn rmf-btn--block" href="' + BASE + '/wishlist">Voir ma wishlist</a>'
    } else {
      ft.innerHTML = '<p class="rmf-muted">Connectez-vous pour retrouver votre liste sur tous vos appareils.</p>' +
        '<a class="rmf-btn rmf-btn--block" href="' + esc(loginUrl()) + '">Me connecter</a>'
    }
  }
  function openDrawer() {
    buildDrawer()
    renderDrawer()
    DRAWER.dlg.show()
  }
  async function onDrawerClick(e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-act]') : null
    if (!t) return
    var act = t.getAttribute('data-act')
    if (act === 'remove') {
      var it = wFind(t.getAttribute('data-pid'))
      if (it) {
        await wToggle(it)
        var f = focusables(DRAWER.panel)
        if (f[0]) f[0].focus()
      }
    } else if (act === 'add') {
      addToCart(t.getAttribute('data-variant'), t)
    }
  }
  async function addToCart(variantId, btn) {
    if (!variantId || btn.disabled) return
    btn.disabled = true
    var label = btn.textContent
    btn.textContent = 'Ajout…'
    var ok = false
    var msg = 'Ajout impossible pour le moment.'
    try {
      var r = await fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      })
      var data = null
      try { data = await r.json() } catch (err) { data = null }
      ok = r.ok
      if (!ok && data && data.description) msg = String(data.description)
    } catch (err) { ok = false }
    btn.disabled = false
    btn.textContent = ok ? 'Ajouté' : label
    toast(ok ? 'Ajouté au panier' : msg)
    if (ok) {
      setTimeout(function () { btn.textContent = label }, 2000)
      /* Rafraîchissement du panier du thème (Prestige : cart:refresh). */
      try {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }))
        document.dispatchEvent(new CustomEvent('rmf:cart-add', { detail: { variant_id: variantId } }))
      } catch (err) { /* no-op */ }
    }
  }

  /* ── Launcher fidélité ── */
  var L = { root: null, btn: null, panel: null, open: false, code: null, confirm: null, msg: null }
  function launcherWanted() {
    return ACTIVE && S.launcher.enabled && (LOGGED || S.launcher.show_to_guests)
  }
  function mountLauncher() {
    if (!launcherWanted() || L.root) return
    var lc = S.launcher
    var root = document.createElement('div')
    root.className = 'rmf-launcher rmf-launcher--' + (lc.position === 'left' ? 'left' : 'right') + (lc.hide_on_mobile ? ' rmf-launcher--hide-mobile' : '')
    root.style.setProperty('--rmf-lx', (Number(lc.offset_x) || 0) + 'px')
    root.style.setProperty('--rmf-ly', (Number(lc.offset_y) || 0) + 'px')
    root.innerHTML =
      '<div class="rmf-panel rmf-ui" id="rmf-panel" role="dialog" aria-labelledby="rmf-panel-title" tabindex="-1" hidden></div>' +
      '<button type="button" class="rmf-b rmf-launcher__btn" aria-expanded="false" aria-controls="rmf-panel"></button>'
    layer().appendChild(root)
    /* Le toast passe au-dessus du launcher sur mobile. */
    LAYER.style.setProperty('--rmf-toast-y', ((Number(lc.offset_y) || 0) + 60) + 'px')
    L.root = root
    L.btn = root.querySelector('.rmf-launcher__btn')
    L.panel = root.querySelector('.rmf-panel')
    L.btn.addEventListener('click', function () { setLauncher(!L.open) })
    L.panel.addEventListener('click', onPanelClick)
    L.panel.addEventListener('submit', onPanelSubmit)
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && L.open) { e.stopPropagation(); setLauncher(false); L.btn.focus() }
    })
    document.addEventListener('click', function (e) {
      var t = e.target
      if (!L.open || !t || !t.isConnected) return
      if (!L.root.contains(t)) setLauncher(false)
    })
    renderLauncher()
  }
  function setLauncher(open) {
    if (!L.root) return
    L.open = open
    L.btn.setAttribute('aria-expanded', open ? 'true' : 'false')
    if (open) {
      renderPanel()
      L.panel.hidden = false
      void L.panel.offsetWidth
      L.panel.classList.add('is-open')
      try { L.panel.focus({ preventScroll: true }) } catch (e) { /* no-op */ }
    } else {
      L.panel.classList.remove('is-open')
      L.panel.hidden = true
      L.confirm = null
    }
  }
  function renderLauncher() {
    if (!L.root) return
    if (!launcherWanted()) { L.root.hidden = true; return }
    L.root.hidden = false
    var label = LOGGED && CUS ? fmtInt(CUS.balance) + ' ' + VARS.monnaie : fill(S.launcher.label)
    L.btn.innerHTML = icon(S.launcher.icon || 'gift') + '<span>' + esc(label) + '</span>'
    L.btn.setAttribute('aria-label', fill(S.launcher.label) + (LOGGED && CUS ? ' — ' + label : ''))
    if (L.open) renderPanel()
  }
  function earnPill(w) {
    if (w.points != null) return '+' + fmtInt(w.points)
    if (w.per_euro != null) return fmtDec(w.per_euro).replace(/,0$/, '') + ' / €'
    return ''
  }
  function renderPanel() {
    var t = S.texts
    var h = ''
    if (!LOGGED || !CUS) {
      h += '<div class="rmf-panel__hd"><h2 class="rmf-h rmf-panel__title" id="rmf-panel-title">' + esc(fill(t.guest_title)) + '</h2>' +
        '<p>' + esc(fill(t.guest_intro)) + '</p>' + closeBtn() + '</div><div class="rmf-panel__bd">'
      var ways = CFG.ways_to_earn || []
      if (ways.length) {
        h += '<h3 class="rmf-h3">' + esc(fill(t.earn_title)) + '</h3><ul class="rmf-list">'
        ways.forEach(function (w) { h += '<li class="rmf-row"><span>' + esc(w.label) + '</span><span class="rmf-pill">' + esc(earnPill(w)) + '</span></li>' })
        h += '</ul>'
      }
      var rw = CFG.rewards || []
      if (rw.length) {
        h += '<h3 class="rmf-h3">' + esc(fill(t.redeem_title)) + '</h3><ul class="rmf-list">'
        rw.forEach(function (r) { h += '<li class="rmf-row"><span>' + esc(r.label) + '</span><span class="rmf-pill">' + esc(fmtInt(r.points_cost) + ' ' + VARS.monnaie) + '</span></li>' })
        h += '</ul>'
      }
      h += '<div class="rmf-stack"><a class="rmf-btn rmf-btn--block" href="' + esc(ROOT + 'account/register') + '">' + esc(fill(t.join_cta)) + '</a>' +
        '<a class="rmf-btn rmf-btn--ghost rmf-btn--block" href="' + esc(loginUrl()) + '">' + esc(fill(t.login_cta)) + '</a></div></div>'
      L.panel.innerHTML = h
      return
    }
    var c = CUS
    var first = CTX.customer_first_name ? String(CTX.customer_first_name) : ''
    var tierLine = ''
    if (c.tier) tierLine = 'Statut ' + c.tier + (c.next_tier ? ' · prochain statut : ' + c.next_tier : '')
    h += '<div class="rmf-panel__hd"><h2 class="rmf-h rmf-panel__title" id="rmf-panel-title">' + esc(first ? 'Bonjour ' + first : 'Bonjour') + '</h2>' +
      (tierLine ? '<p>' + icon('crown') + ' ' + esc(tierLine) + '</p>' : '<p>' + esc(VARS.programme) + '</p>') + closeBtn() + '</div><div class="rmf-panel__bd">'
    if (L.code) h += codeBox(L.code)
    if (L.msg) h += '<p class="rmf-alert" role="alert">' + esc(L.msg) + '</p>'
    h += '<div class="rmf-tiles"><div class="rmf-tile"><div class="rmf-tile__n">' + esc(fmtInt(c.balance)) + '</div><div class="rmf-tile__l">' + esc(VARS.monnaie) + '</div></div>' +
      '<div class="rmf-tile rmf-tile--dim"><div class="rmf-tile__n">' + esc(fmtInt(c.pending)) + '</div><div class="rmf-tile__l">en attente</div></div></div>'
    var nr = c.next_reward
    if (nr && nr.missing > 0) {
      var target = (CFG.rewards || []).filter(function (r) { return r.label === nr.label })[0]
      var cost = target ? Number(target.points_cost) : Number(c.balance) + Number(nr.missing)
      var pct = cost > 0 ? Math.max(0, Math.min(100, (cost - nr.missing) / cost * 100)) : 0
      h += '<p class="rmf-small">Plus que <strong>' + esc(fmtInt(nr.missing) + ' ' + VARS.monnaie) + '</strong> pour ' + esc(nr.label) + '</p>' +
        '<div class="rmf-progress" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + Math.round(pct) + '" aria-label="Progression vers la prochaine récompense"><span style="width:' + pct.toFixed(1) + '%"></span></div>'
    }
    var rw2 = CFG.rewards || []
    if (rw2.length) {
      h += '<h3 class="rmf-h3">' + esc(fill(t.redeem_title)) + '</h3><ul class="rmf-list">'
      rw2.forEach(function (r) {
        var can = r.id && Number(r.points_cost) <= Number(c.balance)
        h += '<li class="rmf-row"><span>' + esc(r.label) + '</span>'
        h += can
          ? '<button type="button" class="rmf-b rmf-pill rmf-pill--act" data-act="use" data-id="' + esc(r.id) + '">Utiliser</button>'
          : '<span class="rmf-pill">' + esc(fmtInt(r.points_cost) + ' ' + VARS.monnaie) + '</span>'
        h += '</li>'
        if (can && L.confirm === r.id) h += '<li class="rmf-confirm">' + confirmHtml(r) + '</li>'
      })
      h += '</ul>'
    }
    if (c.birthday_points && !c.birthday_set) {
      var days = '<option value="">Jour</option>'
      for (var d = 1; d <= 31; d++) days += '<option value="' + d + '">' + d + '</option>'
      var months = '<option value="">Mois</option>'
      MONTHS.forEach(function (m, i) { months += '<option value="' + (i + 1) + '">' + m + '</option>' })
      h += '<form class="rmf-bday" data-form="birthday"><h3 class="rmf-h3">Votre anniversaire</h3>' +
        '<p class="rmf-small">' + esc(fmtInt(c.birthday_points) + ' ' + VARS.monnaie) + ' offerts le jour J.</p>' +
        '<div class="rmf-bday__row"><label class="rmf-sr" for="rmf-bd-d">Jour</label><select class="rmf-field" id="rmf-bd-d" name="day" required>' + days + '</select>' +
        '<label class="rmf-sr" for="rmf-bd-m">Mois</label><select class="rmf-field" id="rmf-bd-m" name="month" required>' + months + '</select>' +
        '<button type="submit" class="rmf-b rmf-btn rmf-btn--sm">Enregistrer</button></div>' +
        '<p class="rmf-small rmf-muted">La date ne pourra plus être modifiée.</p><p class="rmf-err" hidden></p></form>'
    }
    h += '<div class="rmf-stack"><a class="rmf-btn rmf-btn--block" href="' + BASE + '/programme">' + esc(fill(t.member_cta)) + '</a></div></div>'
    L.panel.innerHTML = h
  }
  function closeBtn() {
    return '<button type="button" class="rmf-b rmf-x rmf-panel__x" data-act="close" aria-label="Fermer">' + icon('close') + '</button>'
  }
  function confirmHtml(r) {
    return '<p>Utiliser <strong>' + esc(fmtInt(r.points_cost) + ' ' + VARS.monnaie) + '</strong> pour « ' + esc(r.label) + ' » ? Ils seront débités immédiatement.</p>' +
      '<div class="rmf-confirm__acts"><button type="button" class="rmf-b rmf-btn rmf-btn--sm" data-act="yes" data-id="' + esc(r.id) + '">Confirmer</button>' +
      '<button type="button" class="rmf-b rmf-btn rmf-btn--sm rmf-btn--ghost" data-act="no">Annuler</button></div>'
  }
  function codeBox(code) {
    var exp = code.expires_at ? fmtDate(code.expires_at) : ''
    return '<div class="rmf-code" role="status"><p class="rmf-small">Votre code de réduction' + (exp ? ' (valable jusqu\'au ' + esc(exp) + ')' : '') + ' :</p>' +
      '<div class="rmf-code__row"><code class="rmf-code__v">' + esc(code.code) + '</code>' +
      '<button type="button" class="rmf-b rmf-x" data-act="copy" aria-label="Copier le code">' + icon('copy') + '</button></div>' +
      '<a class="rmf-btn rmf-btn--sm rmf-btn--block" href="' + esc(ROOT + 'discount/' + encodeURIComponent(code.code) + '?redirect=' + encodeURIComponent(ROOT + 'cart')) + '">Appliquer au panier</a></div>'
  }
  async function redeem(rewardId) {
    var r = await api(BASE + '/redeem', { method: 'POST', json: { reward_id: rewardId } })
    if (r.status === 401) { goLogin(); return null }
    if (r.ok && r.data && r.data.ok && r.data.code) return { ok: true, code: r.data.code, expires_at: r.data.expires_at || null }
    return { ok: false, error: (r.data && r.data.error) || 'Échange impossible pour le moment.' }
  }
  async function onPanelClick(e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-act]') : null
    if (!t) return
    var act = t.getAttribute('data-act')
    if (act === 'close') { setLauncher(false); L.btn.focus(); return }
    if (act === 'use') {
      L.confirm = t.getAttribute('data-id')
      L.msg = null
      renderPanel()
      var y = L.panel.querySelector('[data-act="yes"]')
      if (y) y.focus()
      return
    }
    if (act === 'no') {
      var id = L.confirm
      L.confirm = null
      renderPanel()
      var u = L.panel.querySelector('[data-act="use"][data-id="' + (window.CSS && CSS.escape ? CSS.escape(id) : id) + '"]')
      if (u) u.focus()
      return
    }
    if (act === 'yes') {
      if (t.disabled) return
      t.disabled = true
      t.textContent = 'Un instant…'
      var out = await redeem(t.getAttribute('data-id'))
      if (!out) return
      L.confirm = null
      if (out.ok) { L.code = out; L.msg = null } else { L.msg = out.error }
      await refreshConfig()
      renderPanel()
      var focusEl = L.panel.querySelector('.rmf-code, .rmf-alert')
      if (focusEl) { focusEl.setAttribute('tabindex', '-1'); focusEl.focus() }
      return
    }
    if (act === 'copy' && L.code) {
      var done = function () { toast('Code copié') }
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) { await navigator.clipboard.writeText(L.code.code); done(); return }
      } catch (err) { /* repli ci-dessous */ }
      var codeEl = L.panel.querySelector('.rmf-code__v')
      if (codeEl) {
        var range = document.createRange()
        range.selectNodeContents(codeEl)
        var s = window.getSelection()
        s.removeAllRanges()
        s.addRange(range)
        try { if (document.execCommand('copy')) done() } catch (err) { /* no-op */ }
      }
    }
  }
  async function onPanelSubmit(e) {
    var f = e.target
    if (!f || f.getAttribute('data-form') !== 'birthday') return
    e.preventDefault()
    var err = f.querySelector('.rmf-err')
    var day = Number(f.day.value)
    var month = Number(f.month.value)
    if (!day || !month) { err.hidden = false; err.textContent = 'Choisissez le jour et le mois.'; return }
    var btn = f.querySelector('button[type=submit]')
    btn.disabled = true
    var r = await api(BASE + '/birthday', { method: 'POST', json: { day: day, month: month } })
    btn.disabled = false
    if (r.status === 401) { goLogin(); return }
    if (r.ok && r.data && (r.data.ok || r.data.already_set)) {
      toast(r.data.already_set ? 'Votre date d\'anniversaire est déjà enregistrée.' : 'Date d\'anniversaire enregistrée')
      await refreshConfig()
      if (CUS) CUS.birthday_set = true
      renderPanel()
      return
    }
    err.hidden = false
    err.textContent = (r.data && r.data.error) || 'Enregistrement impossible pour le moment.'
  }

  /* ── Panier : échange de points avant le paiement ──
     Hors Shopify Plus, pas de bloc d'app dans le checkout : on échange sur la
     page panier puis /discount/<code>?redirect=/checkout applique le code. */
  function mountCart() {
    if (!ACTIVE || !S.cart.redeem_enabled || !LOGGED || !CUS) return
    if (!/^cart/.test(String(CTX.template || ''))) return
    if (REF.cart && REF.cart.isConnected) return
    var affordable = (CFG.rewards || []).filter(function (r) { return r.id && Number(r.points_cost) <= Number(CUS.balance) })
    if (!affordable.length) return
    var anchor = qsa(document, sel('cart_anchor')).filter(function (a) { return !closest(a, DRAWERS) })[0]
    if (!anchor || !anchor.parentNode) return
    var box = document.createElement('div')
    box.className = 'rmf rmf-ui rmf-cart'
    var h = '<div class="rmf-cart__hd">' + icon(S.launcher.icon || 'gift') + '<div><div class="rmf-cart__title">' + esc(VARS.programme) + '</div>' +
      '<div class="rmf-small rmf-muted">' + esc(fmtInt(CUS.balance) + ' ' + VARS.monnaie) + ' disponibles — la réduction s\'appliquera au paiement.</div></div></div><ul class="rmf-list">'
    affordable.slice(0, 3).forEach(function (r) {
      h += '<li class="rmf-row"><span>' + esc(r.label) + '</span><button type="button" class="rmf-b rmf-pill rmf-pill--act" data-act="use" data-id="' + esc(r.id) + '" data-cost="' + esc(r.points_cost) + '" data-label="' + esc(r.label) + '">Utiliser ' + esc(fmtInt(r.points_cost) + ' ' + VARS.monnaie) + '</button></li>'
    })
    h += '</ul><div class="rmf-cart__confirm" hidden></div><p class="rmf-err" role="alert" hidden></p>'
    box.innerHTML = h
    anchor.parentNode.insertBefore(box, anchor)
    REF.cart = box
    var pending = null
    var cf = box.querySelector('.rmf-cart__confirm')
    var err = box.querySelector('.rmf-err')
    box.addEventListener('click', async function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-act]') : null
      if (!t) return
      var act = t.getAttribute('data-act')
      if (act === 'use') {
        pending = { id: t.getAttribute('data-id'), points_cost: t.getAttribute('data-cost'), label: t.getAttribute('data-label') }
        cf.innerHTML = confirmHtml(pending)
        cf.hidden = false
        err.hidden = true
        cf.querySelector('[data-act="yes"]').focus()
      } else if (act === 'no') {
        cf.hidden = true
        pending = null
      } else if (act === 'yes' && pending) {
        t.disabled = true
        t.textContent = 'Un instant…'
        var out = await redeem(pending.id)
        if (!out) return
        if (out.ok) {
          t.textContent = 'Redirection…'
          location.href = ROOT + 'discount/' + encodeURIComponent(out.code) + '?redirect=' + encodeURIComponent(ROOT + 'checkout')
          return
        }
        cf.hidden = true
        err.hidden = false
        err.textContent = out.error
      }
    })
  }

  /* ── Fiche produit ── */
  function outsideMain(el) {
    return !!(closest(el, OUTSIDE_MAIN) || closest(el, sel('product_card')))
  }
  function findAtc() {
    var list = qsa(document, sel('add_to_cart')).filter(function (b) { return !outsideMain(b) })
    return list.filter(visible)[0] || list[0] || null
  }
  function findSection(atc) {
    var user = S.selectors.product_section
    if (user) return qs(document, user)
    if (atc) return closest(atc, '.shopify-section') || closest(atc, 'main') || null
    var title = qsa(document, sel('product_title')).filter(function (t) { return !outsideMain(t) })[0]
    return title ? (closest(title, '.shopify-section') || closest(title, 'main')) : null
  }
  function firstIn(root, s) {
    return qsa(root, s).filter(function (x) { return !outsideMain(x) })[0] || null
  }
  function productPoints() {
    if (!ACTIVE || !S.product.points_enabled || PD.price == null) return 0
    var excl = (P.excluded_tags || []).map(function (x) { return String(x).toLowerCase().trim() })
    var tags = (CTX.product.tags || []).map(function (x) { return String(x).toLowerCase().trim() })
    if (tags.some(function (x) { return excl.indexOf(x) >= 0 })) return 0
    var mult = CUS && Number(CUS.multiplier) > 0 ? Number(CUS.multiplier) : 1
    var raw = Math.max(0, Number(PD.price) / 100) * Math.max(0, Number(P.earn_ratio) || 0) * mult
    if (P.rounding === 'up') return Math.ceil(raw - 1e-9)
    if (P.rounding === 'nearest') return Math.round(raw)
    return Math.floor(raw + 1e-9)
  }
  function renderPoints() {
    var line = REF.points
    if (!line) return
    var n = productPoints()
    line.hidden = !n
    if (!n) return
    line.innerHTML = '<span class="rmf-points__ic">' + icon(S.launcher.icon || 'gift') + '</span><span>' +
      fillHtml(S.product.points_text, { points: '<strong>' + esc(fmtInt(n)) + '</strong>' }) + '</span>'
  }
  function mountPoints(section, atc) {
    if (!ACTIVE || !S.product.points_enabled) return
    if (REF.points && REF.points.isConnected) return
    var line = document.createElement('div')
    line.className = 'rmf rmf-ui rmf-points'
    line.setAttribute('aria-live', 'polite')
    var price = firstIn(section, sel('product_price'))
    if (price && price.parentNode) price.insertAdjacentElement('afterend', line)
    else {
      var form = atc ? closest(atc, 'form') : null
      if (!form || !form.parentNode) return
      form.parentNode.insertBefore(line, form)
    }
    REF.points = line
    INSERTS++
    renderPoints()
  }
  function variantById(id) {
    var vs = (CTX.product && CTX.product.variants) || []
    for (var i = 0; i < vs.length; i++) if (String(vs[i].id) === String(id)) return vs[i]
    return null
  }
  function setVariant(id, price) {
    if (!id) return
    var v = variantById(id)
    if (!v && price == null) return
    PD.variant = String(id)
    var p = price != null ? Number(price) : Number(v.price)
    if (isFinite(p) && p !== PD.price) { PD.price = p; renderPoints() }
  }
  function watchVariants() {
    document.addEventListener('change', function (e) {
      var t = e.target
      if (t && t.name === 'id' && /^(INPUT|SELECT)$/.test(t.tagName) && !closest(t, OUTSIDE_MAIN)) setVariant(t.value)
    }, true)
    var onEvt = function (e) {
      var d = e && e.detail
      var v = d && (d.variant || (d.data && d.data.variant))
      if (v && v.id) setVariant(v.id, v.price)
    }
    document.addEventListener('variant:change', onEvt, true)
    document.addEventListener('variant:changed', onEvt, true)
    var last = location.search
    var check = function () {
      if (location.search === last) return
      last = location.search
      var m = /[?&]variant=(\d+)/.exec(last)
      if (m) setVariant(m[1])
    }
    window.addEventListener('popstate', check)
    setInterval(check, 700)
  }
  function mountTitleStars(section) {
    var mode = S.product.stars
    if (!(mode === 'on' || (mode === 'auto' && !CTX.product.has_theme_rating))) return
    if ((REF.stars && REF.stars.isConnected) || REF.starsBusy) return
    var title = firstIn(section, sel('product_title'))
    if (!title || !title.parentNode) return
    REF.starsBusy = true
    getSummary(0).then(function (s) {
      REF.starsBusy = false
      if (!s || !s.total_reviews || !title.isConnected) return
      var n = Number(s.total_reviews)
      var href = S.product.reviews_block_enabled ? '#rmf-reviews' : BASE + '/avis?product_id=' + encodeURIComponent(CTX.product.id)
      var el = frag('<div class="rmf rmf-ui rmf-title-stars"><a href="' + esc(href) + '">' + starsHtml(s.average_rating) +
        '<span>' + esc(fmtDec(s.average_rating)) + ' · ' + esc(fmtInt(n)) + ' avis</span></a></div>')
      el.querySelector('a').addEventListener('click', function (e) {
        if (!S.product.reviews_block_enabled || !REF.reviews) return
        e.preventDefault()
        loadReviews()
        REF.reviews.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' })
      })
      title.insertAdjacentElement('afterend', el)
      INSERTS++
      REF.stars = el
    })
  }
  function mountPdpHeart(atc) {
    if (!S.product.wishlist_button || !atc || !atc.parentNode) return
    if (REF.heart && REF.heart.isConnected) return
    var b = document.createElement('button')
    b.type = 'button'
    b.className = 'rmf rmf-b rmf-pdp-heart'
    b.innerHTML = icon('heart')
    setHeart(b, !!wFind(CTX.product.id, CTX.product.handle))
    b.addEventListener('click', function (e) {
      e.preventDefault()
      e.stopPropagation()
      var p = CTX.product
      var existing = wFind(p.id, p.handle)
      wToggle(existing || {
        product_id: p.id,
        variant_id: PD.variant || p.variant_id,
        handle: p.handle,
        title: p.title,
        image: p.image,
        price: PD.price != null ? PD.price / 100 : null
      })
    })
    var parent = atc.parentNode
    var cs = getComputedStyle(parent)
    if (/flex/.test(cs.display) && /^row/.test(cs.flexDirection) && cs.flexWrap === 'nowrap') {
      atc.insertAdjacentElement('afterend', b)
    } else {
      /* Bouton panier + cœur sur une même ligne (le bouton du thème reste
         dans son formulaire). */
      var row = document.createElement('div')
      row.className = 'rmf rmf-atc-row'
      parent.insertBefore(row, atc)
      row.appendChild(atc)
      row.appendChild(b)
    }
    var hgt = atc.offsetHeight
    if (hgt >= 32 && hgt <= 80) { b.style.width = hgt + 'px'; b.style.height = hgt + 'px' }
    /* Mode thème : même arrondi que le bouton panier du thème. */
    if (S.style.mode !== 'custom') {
      var br = getComputedStyle(atc).borderTopLeftRadius
      if (br && /^[\d.]+px$/.test(br)) b.style.borderRadius = Math.min(parseFloat(br), hgt / 2 || 999) + 'px'
    }
    REF.heart = b
    INSERTS++
  }

  /* ── Avis sur la fiche produit ── */
  var RV = { items: [], offset: 0, hasMore: false, summary: null, loading: false, started: false, qaOpen: false }
  var SUMMARY0 = null
  function getSummary(offset) {
    var load = function () {
      return api(BASE + '/avis/summary?product_id=' + encodeURIComponent(CTX.product.id) + '&offset=' + offset)
        .then(function (r) { return r.ok && r.data ? r.data : null })
    }
    if (offset) return load()
    if (!SUMMARY0) SUMMARY0 = load()
    return SUMMARY0
  }
  function mountReviews(section, atc) {
    if (!S.product.reviews_block_enabled) return
    if (REF.reviews && REF.reviews.isConnected) return
    var host = null
    if (S.selectors.product_section) host = section
    else {
      var cont = atc ? closest(atc, CONTAINERS) : null
      host = cont && section.contains(cont) ? cont : section
    }
    var blk = document.createElement('section')
    blk.className = 'rmf rmf-ui rmf-reviews' + (host === section && !S.selectors.product_section ? ' rmf-reviews--pad' : '')
    blk.id = 'rmf-reviews'
    blk.setAttribute('aria-labelledby', 'rmf-reviews-title')
    blk.innerHTML = '<h2 class="rmf-h rmf-reviews__title" id="rmf-reviews-title">' + esc(fill(S.product.reviews_title)) + '</h2>' +
      '<div class="rmf-reviews__bd"><p class="rmf-muted">Chargement des avis…</p></div>'
    host.appendChild(blk)
    // Conteneur du thème pleine largeur (bloc collé aux bords de l'écran) :
    // on applique notre propre largeur de page et nos marges.
    try {
      var box = blk.getBoundingClientRect()
      if (box.width && (box.left < 12 || (document.documentElement.clientWidth - box.right) < 12)) blk.classList.add('rmf-reviews--pad')
    } catch (e) { /* mesure indisponible */ }
    INSERTS++
    REF.reviews = blk
    blk.addEventListener('click', onReviewsClick)
    blk.addEventListener('submit', onQaSubmit)
    if (RV.summary) { renderReviews(); return }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (en) { return en.isIntersecting })) { io.disconnect(); loadReviews() }
      }, { rootMargin: '400px 0px' })
      io.observe(blk)
    } else {
      loadReviews()
    }
  }
  async function loadReviews() {
    if (RV.started) return
    RV.started = true
    var s = await getSummary(0)
    if (!s) {
      RV.started = false
      var bd = REF.reviews && REF.reviews.querySelector('.rmf-reviews__bd')
      if (bd) bd.innerHTML = '<p class="rmf-muted">Les avis sont indisponibles pour le moment.</p>'
      return
    }
    RV.summary = s
    RV.items = (s.reviews || []).slice()
    RV.offset = RV.items.length
    RV.hasMore = !!s.has_more
    renderReviews()
  }
  function reviewHtml(r) {
    var photos = (r.photos || []).filter(Boolean)
    return '<article class="rmf-rv">' +
      '<div class="rmf-rv__meta"><span><strong>' + esc(r.customer_name || 'Anonyme') + '</strong>' +
        (r.is_verified_buyer ? ' · <span class="rmf-rv__ok">' + icon('check') + 'Achat vérifié</span>' : '') + '</span>' +
        '<time datetime="' + esc(r.created_at || '') + '">' + esc(fmtDate(r.created_at)) + '</time></div>' +
      starsHtml(r.rating, 'rmf-stars--sm') +
      (r.title ? '<h3 class="rmf-rv__title">' + esc(r.title) + '</h3>' : '') +
      (r.body ? '<p class="rmf-rv__body">' + esc(r.body) + '</p>' : '') +
      (photos.length ? '<div class="rmf-thumbs">' + photos.map(function (u) { return thumbHtml(u) }).join('') + '</div>' : '') +
      (r.merchant_reply ? '<div class="rmf-rv__reply"><strong>Réponse de ' + esc(VARS.boutique || 'la boutique') + '</strong><p>' + esc(r.merchant_reply) + '</p></div>' : '') +
      '</article>'
  }
  function thumbHtml(u) {
    return '<button type="button" class="rmf-b rmf-thumb" data-act="photo" data-src="' + esc(u) + '" aria-label="Agrandir la photo"><img src="' + esc(imgUrl(u, 200)) + '" alt="" loading="lazy"></button>'
  }
  function renderReviews() {
    var blk = REF.reviews
    if (!blk || !RV.summary) return
    var s = RV.summary
    var total = Number(s.total_reviews) || 0
    var h = ''
    if (total > 0) {
      var dist = s.rating_distribution || {}
      h += '<div class="rmf-rv-head"><div class="rmf-rv-score"><div class="rmf-rv-avg">' + esc(fmtDec(s.average_rating)) + '</div>' + starsHtml(s.average_rating) +
        '<div class="rmf-small rmf-muted">' + esc(fmtInt(total)) + ' avis' +
        (s.recommendation_rate != null ? ' · ' + esc(fmtInt(s.recommendation_rate)) + ' % recommandent' : '') + '</div></div>'
      h += '<div class="rmf-rv-dist">'
      for (var k = 5; k >= 1; k--) {
        var n = Number(dist[k] || dist[String(k)] || 0)
        var pct = total ? n / total * 100 : 0
        h += '<div class="rmf-rv-bar"><span>' + k + '</span><span class="rmf-rv-track" aria-hidden="true"><span style="width:' + pct.toFixed(1) + '%"></span></span><span>' + esc(fmtInt(n)) + '</span></div>'
      }
      h += '</div><div class="rmf-rv-cta"><button type="button" class="rmf-b rmf-btn rmf-btn--ghost" data-act="write">Donner mon avis</button></div></div>'
      var photos = []
      RV.items.forEach(function (r) { (r.photos || []).forEach(function (u) { if (u && photos.indexOf(u) < 0) photos.push(u) }) })
      if (photos.length) h += '<div class="rmf-thumbs rmf-thumbs--strip">' + photos.slice(0, 12).map(thumbHtml).join('') + '</div>'
      h += '<div class="rmf-rv-list">' + RV.items.map(reviewHtml).join('') + '</div>'
      if (RV.hasMore) h += '<div class="rmf-center"><button type="button" class="rmf-b rmf-btn rmf-btn--ghost" data-act="more">Voir plus d\'avis</button></div>'
    } else {
      h += '<div class="rmf-rv-empty"><p>Aucun avis pour le moment.</p><button type="button" class="rmf-b rmf-btn rmf-btn--ghost" data-act="write">Donner mon avis</button></div>'
    }
    var qa = s.qa || []
    h += '<div class="rmf-qa"><h3 class="rmf-h3">Questions-réponses' + (qa.length ? ' (' + qa.length + ')' : '') + '</h3>'
    if (qa.length) {
      h += qa.map(function (q) {
        return '<div class="rmf-qa__it"><p class="rmf-qa__q">' + esc(q.question_text) + '</p>' + (q.answers || []).map(function (a) {
          var who = a.author_type === 'merchant' ? 'Réponse de ' + (VARS.boutique || 'la boutique') : (a.author_name || 'Anonyme')
          return '<div class="rmf-qa__a"><span class="rmf-small rmf-muted">' + esc(who) + '</span><p>' + esc(a.answer_text) + '</p></div>'
        }).join('') + '</div>'
      }).join('')
    } else {
      h += '<p class="rmf-muted rmf-small">Aucune question pour le moment.</p>'
    }
    h += '<button type="button" class="rmf-b rmf-link" data-act="ask" aria-expanded="' + (RV.qaOpen ? 'true' : 'false') + '" aria-controls="rmf-qa-form">Poser une question</button>' +
      '<form class="rmf-qa__form" id="rmf-qa-form" data-form="question"' + (RV.qaOpen ? '' : ' hidden') + '>' +
      '<label class="rmf-label" for="rmf-qa-text">Votre question</label>' +
      '<textarea class="rmf-field" id="rmf-qa-text" name="question" rows="3" maxlength="1000" required></textarea>' +
      '<div class="rmf-qa__acts"><button type="submit" class="rmf-b rmf-btn rmf-btn--sm">Envoyer</button><span class="rmf-small rmf-msg" role="status"></span></div></form></div>'
    blk.querySelector('.rmf-reviews__bd').innerHTML = h
  }
  async function onReviewsClick(e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-act]') : null
    if (!t) return
    var act = t.getAttribute('data-act')
    if (act === 'write') {
      if (!LOGGED) { goLogin(); return }
      openReviewModal()
    } else if (act === 'photo') {
      openLightbox(t.getAttribute('data-src'))
    } else if (act === 'more') {
      if (RV.loading) return
      RV.loading = true
      t.disabled = true
      t.textContent = 'Chargement…'
      var s = await getSummary(RV.offset)
      RV.loading = false
      if (s) {
        var list = s.reviews || []
        var firstNew = RV.items.length
        RV.items = RV.items.concat(list)
        RV.offset += list.length
        RV.hasMore = !!s.has_more && list.length > 0
        renderReviews()
        var arts = REF.reviews.querySelectorAll('.rmf-rv')
        if (arts[firstNew]) { arts[firstNew].setAttribute('tabindex', '-1'); arts[firstNew].focus({ preventScroll: true }) }
      } else {
        t.disabled = false
        t.textContent = 'Voir plus d\'avis'
        toast('Chargement impossible pour le moment.')
      }
    } else if (act === 'ask') {
      if (!LOGGED) { goLogin(); return }
      RV.qaOpen = !RV.qaOpen
      var f = REF.reviews.querySelector('.rmf-qa__form')
      f.hidden = !RV.qaOpen
      t.setAttribute('aria-expanded', RV.qaOpen ? 'true' : 'false')
      if (RV.qaOpen) f.querySelector('textarea').focus()
    }
  }
  async function onQaSubmit(e) {
    var f = e.target
    if (!f || f.getAttribute('data-form') !== 'question') return
    e.preventDefault()
    var msg = f.querySelector('.rmf-msg')
    var q = String(f.question.value || '').trim()
    if (q.length < 5) { msg.textContent = 'Votre question est trop courte.'; return }
    var btn = f.querySelector('button[type=submit]')
    btn.disabled = true
    var fd = new FormData()
    fd.append('product_id', String(CTX.product.id))
    fd.append('question', q)
    var r = await api(BASE + '/avis/question', { method: 'POST', form: fd })
    btn.disabled = false
    if (r.status === 401) { goLogin(); return }
    if (r.ok && r.data && r.data.ok !== false) {
      f.question.value = ''
      msg.textContent = 'Merci ! Votre question sera publiée avec sa réponse.'
      return
    }
    msg.textContent = (r.data && r.data.error) || 'Envoi impossible pour le moment.'
  }

  /* Fenêtre « Donner mon avis » */
  var RM = null
  function buildReviewModal() {
    if (RM && RM.root.isConnected) return RM
    var stars = ''
    for (var i = 1; i <= 5; i++) {
      stars += '<input class="rmf-sr" type="radio" name="rating" id="rmf-rate-' + i + '" value="' + i + '"' + (i === 5 ? ' required' : '') + '>' +
        '<label for="rmf-rate-' + i + '" data-v="' + i + '">' + icon('star') + '<span class="rmf-sr">' + i + ' sur 5</span></label>'
    }
    var first = CTX.customer_first_name ? String(CTX.customer_first_name) : ''
    var root = frag(
      '<div class="rmf-modal" hidden><div class="rmf-overlay" data-rmf-close></div>' +
      '<div class="rmf-modal__panel rmf-ui" role="dialog" aria-modal="true" aria-labelledby="rmf-rm-title" tabindex="-1">' +
        '<div class="rmf-modal__hd"><h2 class="rmf-h" id="rmf-rm-title">Donner mon avis</h2>' +
        '<button type="button" class="rmf-b rmf-x" data-rmf-close aria-label="Fermer">' + icon('close') + '</button></div>' +
        '<form class="rmf-form" novalidate>' +
          '<p class="rmf-small rmf-muted">' + esc(CTX.product.title || '') + '</p>' +
          '<fieldset class="rmf-fs"><legend class="rmf-label">Votre note</legend><div class="rmf-rate">' + stars + '</div></fieldset>' +
          '<label class="rmf-label" for="rmf-rm-name">Prénom affiché</label><input class="rmf-field" id="rmf-rm-name" name="name" maxlength="60" autocomplete="given-name" value="' + esc(first) + '">' +
          '<label class="rmf-label" for="rmf-rm-t">Titre</label><input class="rmf-field" id="rmf-rm-t" name="title" maxlength="120">' +
          '<label class="rmf-label" for="rmf-rm-b">Votre avis</label><textarea class="rmf-field" id="rmf-rm-b" name="body" rows="5" minlength="10" maxlength="2000" required aria-describedby="rmf-rm-bh"></textarea>' +
          '<p class="rmf-small rmf-muted" id="rmf-rm-bh">Entre 10 et 2 000 caractères.</p>' +
          '<fieldset class="rmf-fs"><legend class="rmf-label">Recommandez-vous cet article ?</legend><div class="rmf-radios">' +
            '<label><input type="radio" name="reco" value="oui"> Oui</label><label><input type="radio" name="reco" value="non"> Non</label></div></fieldset>' +
          '<label class="rmf-label" for="rmf-rm-p">Photos (3 maximum, 3 Mo chacune)</label>' +
          '<input class="rmf-field rmf-file" id="rmf-rm-p" name="photos" type="file" accept="image/*" multiple>' +
          '<p class="rmf-err" role="alert" hidden></p>' +
          '<button type="submit" class="rmf-b rmf-btn rmf-btn--block">Envoyer mon avis</button>' +
        '</form>' +
        '<div class="rmf-done" hidden>' + icon('check') + '<p><strong>Merci !</strong> Votre avis a bien été envoyé — il sera publié après validation.</p>' +
          '<button type="button" class="rmf-b rmf-btn" data-rmf-close>Fermer</button></div>' +
      '</div></div>')
    layer().appendChild(root)
    var panel = root.querySelector('.rmf-modal__panel')
    RM = { root: root, panel: panel, dlg: makeDialog(root, panel), form: root.querySelector('.rmf-form') }
    RM.form.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'rating') paintRate(Number(e.target.value))
    })
    RM.form.addEventListener('submit', onReviewSubmit)
    return RM
  }
  function paintRate(v) {
    qsa(RM.form, '.rmf-rate label').forEach(function (l) { l.classList.toggle('is-on', Number(l.getAttribute('data-v')) <= v) })
  }
  function openReviewModal() {
    buildReviewModal()
    RM.form.hidden = false
    RM.panel.querySelector('.rmf-done').hidden = true
    RM.dlg.show()
  }
  async function onReviewSubmit(e) {
    e.preventDefault()
    var f = RM.form
    var err = f.querySelector('.rmf-err')
    var fail = function (m, field) {
      err.hidden = false
      err.textContent = m
      if (field && field.focus) field.focus()
    }
    var rating = f.querySelector('input[name=rating]:checked')
    var body = String(f.body.value || '').trim()
    if (!rating) return fail('Choisissez une note de 1 à 5.', f.querySelector('input[name=rating]'))
    if (body.length < 10) return fail('Votre avis doit contenir au moins 10 caractères.', f.body)
    if (body.length > 2000) return fail('Votre avis ne doit pas dépasser 2 000 caractères.', f.body)
    var files = Array.prototype.slice.call(f.photos.files || [])
    if (files.length > 3) return fail('3 photos maximum.', f.photos)
    for (var i = 0; i < files.length; i++) {
      if (!/^image\//.test(files[i].type)) return fail('Seules les images sont acceptées.', f.photos)
      if (files[i].size > 3 * 1024 * 1024) return fail('Chaque photo doit peser 3 Mo maximum.', f.photos)
    }
    err.hidden = true
    var fd = new FormData()
    fd.append('product_id', String(CTX.product.id))
    fd.append('rating', rating.value)
    fd.append('name', String(f.name.value || '').trim())
    fd.append('title', String(f.title.value || '').trim())
    fd.append('body', body)
    var reco = f.querySelector('input[name=reco]:checked')
    if (reco) fd.append('reco', reco.value)
    files.forEach(function (file) { fd.append('photos', file) })
    var btn = f.querySelector('button[type=submit]')
    btn.disabled = true
    btn.textContent = 'Envoi…'
    var r = await api(BASE + '/avis/submit', { method: 'POST', form: fd })
    btn.disabled = false
    btn.textContent = 'Envoyer mon avis'
    if (r.status === 401) { goLogin(); return }
    if (r.ok && r.data && r.data.ok) {
      f.reset()
      paintRate(0)
      f.hidden = true
      var done = RM.panel.querySelector('.rmf-done')
      done.hidden = false
      done.querySelector('button').focus()
      return
    }
    fail((r.data && r.data.error) || 'Envoi impossible pour le moment.')
  }

  /* Visionneuse photo */
  var LB = null
  function openLightbox(src) {
    if (!src) return
    if (!LB || !LB.root.isConnected) {
      var root = frag('<div class="rmf-lightbox" hidden><div class="rmf-overlay" data-rmf-close></div>' +
        '<div class="rmf-lightbox__panel" role="dialog" aria-modal="true" aria-label="Photo client" tabindex="-1">' +
        '<img alt="Photo jointe à un avis">' +
        '<button type="button" class="rmf-b rmf-x rmf-lightbox__x" data-rmf-close aria-label="Fermer">' + icon('close') + '</button></div></div>')
      layer().appendChild(root)
      var panel = root.querySelector('.rmf-lightbox__panel')
      LB = { root: root, panel: panel, img: root.querySelector('img'), dlg: makeDialog(root, panel) }
      panel.addEventListener('click', function (e) { if (e.target === panel) LB.dlg.hide() })
    }
    LB.img.src = src
    LB.dlg.show()
  }

  /* ── Montage (idempotent : relancé par le MutationObserver) ── */
  var remounts = 0
  var INSERTS = 0
  function mountProduct() {
    var p = CTX.product
    if (!p || !p.id) return
    var atc = findAtc()
    var section = findSection(atc)
    if (!section) return
    mountPoints(section, atc)
    mountTitleStars(section)
    mountPdpHeart(atc)
    mountReviews(section, atc)
  }
  function mountAll() {
    try { mountHeader() } catch (e) { /* no-op */ }
    try { mountCardHearts() } catch (e) { /* no-op */ }
    try { mountProduct() } catch (e) { /* no-op */ }
    try { mountCart() } catch (e) { /* no-op */ }
  }
  function observe() {
    if (!('MutationObserver' in window)) return
    /* Garde-fou : un thème qui retirerait nos éléments en boucle ne doit
       pas provoquer de réinsertions infinies. */
    var run = throttle(function () {
      var before = INSERTS
      mountAll()
      if (INSERTS > before && ++remounts > 500) mo.disconnect()
    }, 300)
    var mo = new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var t = list[i].target
        if (t && t.closest && t.closest('.rmf')) continue
        if (list[i].addedNodes.length || list[i].removedNodes.length) { run(); return }
      }
    })
    mo.observe(document.body, { childList: true, subtree: true })
  }

  function readContext() {
    var el = document.getElementById('rmf-context')
    if (!el) return {}
    try { return JSON.parse(el.textContent || '{}') || {} } catch (e) { return {} }
  }

  async function init() {
    CTX = readContext()
    try { ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/' } catch (e) { ROOT = '/' }
    if (ROOT.slice(-1) !== '/') ROOT += '/'
    var c = await loadConfig(false)
    if (!c || !c.settings) return
    setConfig(c)
    if (CTX.product && CTX.product.id) {
      PD.variant = CTX.product.variant_id != null ? String(CTX.product.variant_id) : null
      PD.price = CTX.product.price != null ? Number(CTX.product.price) : null
      var m = /[?&]variant=(\d+)/.exec(location.search)
      if (m) setVariant(m[1])
    }
    applyTheme()
    layer()
    document.addEventListener('rmf:wishlist-change', function () {
      syncHearts()
      syncHeader()
      if (DRAWER && DRAWER.dlg.isOpen()) renderDrawer()
    })
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-rmf-open="wishlist"], a[href="#rmf-wishlist"]') : null
      if (t) { e.preventDefault(); openDrawer() }
    })
    mountLauncher()
    mountAll()
    if (CTX.product && CTX.product.id) watchVariants()
    observe()
    if (wishlistUsed()) wLoad()
    window.RMFidelite = { openWishlist: openDrawer, refresh: mountAll }
  }

  function start() {
    init().catch(function () { /* silencieux côté vitrine */ })
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start)
  else start()
})()
